export const enClientPortalValueCheckPageLayout = {
    sectionLabel: 'VALUATION',
    overviewMetricGrid: {
        changeFromPreviousValuation: 'Change from previous valuation',
        mortgageLendingValueComparisonLabel: 'Mortgage Lending Value',
    },
    baseValuationWidget: {
        title: 'Underlying valuation report',
    },
    tenantSummaryWidget: {
        categoryLabel: 'Category',
        baseLabel: 'Base valuation',
        groupLabels: {
            rentable: 'rentable',
            rented: 'rented',
            vacant: 'vacant',
        },
        rowLabels: {
            area: 'Area',
            units: 'Units',
            parkingSpaces: 'Parking spaces',
        },
    },
    marketDataWidget: {
        existingRents: 'Existing rents',
    },
    landMarketDataWidget: {
        title: 'Land market reports',
    },
}
